import { usePermissions } from 'hooks/usePermissions'

/**
 * Whether this user may enter or correct index values. Admins always can; anyone else needs
 * Servicing.RateIndexes.Values. Mirrors the backend check in RateIndexController.
 */
export const useCanEditRateIndexValues = () => {
  const { hasPermission } = usePermissions()
  return hasPermission('AdminTools') || hasPermission('Servicing.RateIndexes.Values')
}
